/**
 * Converts a string to a CSS class name compatible format (kebab-case)
 * @param input - The input string to convert
 * @returns The CSS class name string
 *
 * @example
 * ```typescript
 * toClassName("Pending") // "pending"
 * toClassName("SENT") // "sent"
 * toClassName("TeamRole.Admin") // "team-role-admin"
 * toClassName("camelCase") // "camel-case"
 * ```
 */
export function toClassName(input: string): string {
  return input
    .replace(/([a-z])([A-Z])/g, "$1-$2") // camelCase -> camel-Case
    .replace(/[\s_.]+/g, "-") // spaces, underscores, dots -> hyphens
    .toLowerCase() // uppercase -> lowercase
    .replace(/^-+|-+$/g, "") // trim leading/trailing hyphens
}
